import React from 'react';
import autobind from "autobind-decorator";
import { PureComponent, Serialize, GroupBox } from 'core/components';
import { Row, Col, CardContent, CardFooter } from 'core/components/Framework7';

import './styles.css';

const Price = Serialize.Price;

const styles = {
  rowMoney: {
    // padding: '16px',
    // margin: '10px',
    // backgroundImage: 'linear-gradient(to right, #f3f3f3 , white)',
    // boxShadow: '4px 3px 6px #e4e4e4',
    // borderRadius: '5px',
    /* padding: 0 7px 52px 7px; */
  },

  titleDetail: {
    paddingBottom: '6px',
    color: 'gray',
    borderBottom: '1px solid #ECECEC',
    fontSize: '13px',
  },

  dataDetail: {
    margin: '10px 0',
    fontSize: '13px',
    color: '#2A2929',
  },

  priceDetail: {
    textAlign: 'left',
    fontSize: '13px',
    margin: '10px 0',
    color: '#2A2929',
  },

  priceDetailDiscount: {
    textAlign: 'left',
    fontSize: '13px',
    margin: '10px 0',
    color: 'red',
  },
}

class Description extends PureComponent {
  constructor(props) {
    super(props);
  }

  static get defaultProps() {
    return {
      gift: 0,
    }
  }

  render() {
    const { sumBefore, sumOfDiscounts, gift, delivery, sumAfter } = this.props;
    // console.log('sumBefore:', sumBefore, 'sumOfDiscounts:', sumOfDiscounts, 'sumAfter:', sumAfter, 'gift value:', gift)

    // const totallPayments = (delivery || delivery == 0) ? sumAfter + delivery : sumAfter;

    return (
      <GroupBox outline
        title={'اطلاعات پرداخت'}
        className={'paymentDetails'}
      >
        <CardContent>
          <Row>
            <Col width="50">
              {'مبلغ کل قبل از تخفیف'}
            </Col>
            <Col width="50">
              <Price price={sumBefore} hasExtension={true} />
            </Col>
          </Row>
          <Row>
            <Col width="50">
              {'مجموع تخفیف کالاها'}
            </Col>
            <Col width="50" className={'discountPrice'}>
              <Price price={sumOfDiscounts} hasExtension={true} round={'floor'} />
            </Col>
          </Row>
          <Row>
            <Col width="50">
              {'مبلغ کد تخفیف'}
            </Col>
            <Col width="50">
              <Price price={gift || 0} hasExtension={true} />
            </Col>
          </Row>
          {/* <Row>
            <Col width="50">
              {'اعتبار کیف پول'}
            </Col>
            <Col width="50">
              <Price price={sumBefore} hasExtension={true} />
            </Col>
          </Row> */}
          <Row>
            <Col width="50">
              {'هزینه ارسال'}
            </Col>
            <Col width="50">
              <Price price={delivery} hasExtension={true} />
            </Col>
          </Row>
        </CardContent>
        <CardFooter style={{ backgroundColor: 'var(--f7-card-outline-border-color)', color: 'var(--color-black)' }}>
          <Row>
            <Col width="50">
              {'مبلغ قابل پرداخت'}
            </Col>
            <Col width="50">
              <Price price={sumAfter} hasExtension={true} />
            </Col>
          </Row>
        </CardFooter>
      </GroupBox>
    )
  }
}

export default autobind(Description);
